/* Display-only expiry guard. No analytics, cart, pricing or network requests. */
(() => {
  if (customElements.get('skrt-checkout-offer')) return;

  class SkrtCheckoutOffer extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.start = Number(this.dataset.offerStart);
      this.end = Number(this.dataset.offerEnd);
      this.serverNow = Number(this.dataset.serverNow);
      this.mountedAt = performance.now();
      if (!Number.isFinite(this.start) || !Number.isFinite(this.end)
          || !Number.isFinite(this.serverNow) || this.start <= 0
          || this.end <= this.start || this.serverNow < this.start
          || this.serverNow >= this.end) return;

      this.onReturn = () => this.refresh();
      document.addEventListener('visibilitychange', this.onReturn);
      window.addEventListener('pageshow', this.onReturn);
      this.refresh();
    }

    disconnectedCallback() {
      window.clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.onReturn);
      window.removeEventListener('pageshow', this.onReturn);
      this.hidden = true;
    }

    refresh() {
      window.clearTimeout(this.expiryTimer);
      const serverElapsed = this.serverNow + (performance.now() - this.mountedAt) / 1000;
      const now = Math.max(Date.now() / 1000, serverElapsed);
      const active = Number.isFinite(now) && now >= this.start && now < this.end;
      this.hidden = !active;
      if (!active) return;
      // Stay within signed 32-bit timeout limits and expire an already-open tab.
      this.expiryTimer = window.setTimeout(() => this.refresh(),
        Math.min((this.end - now) * 1000, 2147483000));
    }
  }

  customElements.define('skrt-checkout-offer', SkrtCheckoutOffer);
})();
